/* eslint-disable max-lines-per-function */
import "./after-blanks-added-modal.scss";
import { EventBus, Events } from "jiffy-store";
import { productItemsPluralizer, commaFormat } from "common/product-items-pluralizer";

EventBus.on(Events.MOBILE_GRID_SUBMIT, () => {
  const modal = $("#after-blanks-added-modal");
  if (modal.length === 0) return;

  modal.find(".after-blanks-added-modal__modal-loaded").hide();
  modal.find(".after-blanks-added-modal__modal-loading").show();

  modal.modal("show");
});

EventBus.on(Events.ITEMS_ADDED_TO_CART, ({ target: data }) => {
  const modal = $("#after-blanks-added-modal");
  if (modal.length === 0) return;

  const {
    blanks,
    quantity: totalQuantity,
    show_price_with_decoration_cost: showPriceWithDecorationCost
  } = data;
  const { products, totals } = blanks;

  window.itemsInCart = blanks.totals.quantity;

  const modalTitle = modal.find(".after-blanks-added-modal__title");
  modalTitle.text(`${productItemsPluralizer(totalQuantity, "Product")} Successfully Added`);

  const modalSubTitle = modal.find(".after-blanks-added-modal__subtitle");
  modalSubTitle.text(
    `Your cart contains ${productItemsPluralizer(totals.quantity, "decorated item")}`
  );

  const sortedProducts = products.sort((a, b) => b.updated_at.localeCompare(a.updated_at));
  const maxUpdatedAt = sortedProducts[0].updated_at;
  const modalItems = modal.find(".after-blanks-added-modal__line-items--data");
  modalItems.empty();
  const cartItems = $.map(
    sortedProducts,
    ({
      size,
      quantity,
      catalog_number: catalogNumber,
      color_name: colorName,
      discounted_price: discountedPrice,
      decorated_price: decoratedPrice,
      updated_at: updatedAt
    }) => {
      const highlightClass =
        updatedAt === maxUpdatedAt ? "after-blanks-added-modal__line-item--just-added" : "";
      let price = showPriceWithDecorationCost === true ? decoratedPrice : discountedPrice;
      price = parseFloat(price).toFixed(2);

      return `
        <div class="after-blanks-added-modal__line-item ${highlightClass}">
          <div class="after-blanks-added-modal__line-item-title">${catalogNumber} ${colorName} ${size}</div>
          <div class="after-blanks-added-modal__line-item-price">$${price}</div>
          <div class="after-blanks-added-modal__line-item-qty">${commaFormat(quantity)}</div>
        </div>
     `;
    }
  );
  modalItems.append(cartItems.join(""));

  modal.find(".after-blanks-added-modal__modal-loaded").show();
  modal.find(".after-blanks-added-modal__modal-loading").hide();

  const viewCartButton = $(".js-button-go-next", modal);
  viewCartButton.get(0).scrollIntoView();
  viewCartButton.focus();
});
